import { Component } from '@angular/core';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../cms/block/abstract-cms-block.component';

/**
 * Block content interface
 */
export interface IBasketReturnMessageContent extends NICmsContentComponent.IData {
    text: string;
}

/**
 * Component definition
 */
@Component({
    selector: 'basket-return-message',
    template: `<span *iCms="'text' of content; content: 'html'"></span>`,
    standalone: true,
    imports: [ICmsClientModule]
})
@ICmsComponent<BasketReturnMessageComponent>({
    id: 'basket-return-message',
    block: {
        url: 'basket-return-message'
    },
    onDemandOnly: true,
    name: 'Basket return message',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'text',
            title: 'Text'
        }
    ]
})
export class BasketReturnMessageComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IBasketReturnMessageContent;
}
